import React from 'react';
import { NoRecords } from '../../Components/Shimmer';
import { formatDate } from '../../Components/InputElements';

const HolidayList = ({holidayList=[]}) => {
    return (
        <div>
            <div><h5>Holiday List</h5></div>
            <div className='card'>
                <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}> 
                    <table className={` position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped`}>
                        <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                            <tr>
                                <th className='text-center noWrap'>Sr.No.</th>
                                <th className='text-center noWrap'>Holiday Date</th>
                                <th className='noWrap'>Holiday Title</th>
                                <th className='noWrap'>Holiday Type</th>
                            </tr>
                        </thead>
                        {holidayList?.length === 0 ?
                            <tbody>
                                <tr>
                                    <td colSpan={4}>
                                        <NoRecords />
                                    </td>
                                </tr>
                            </tbody> :
                            <tbody>
                                {
                                    holidayList?.map((row,idx) => {
                                        return <tr key={row.expense_id}>
                                            <td className=' text-center'>{idx+1}</td>
                                            <td className=' text-center'>{row.calendar_festival_date? formatDate(row?.calendar_festival_date) : "--"}</td>
                                            <td>{row.calendar_festivals_name || "--"}</td>
                                            <td>{row.is_restricted_holiday || "--"}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        }

                    </table>
                </div>
            </div>
        </div>
    );
}

export default HolidayList;
